export default __webpack_public_path__ + "static/media/resumeJPG.75aa077e.jpeg";